<!-- Off-screen render host: only the chart components mount here so their exact
     Chart.js images can be captured (getChartImages) and POSTed to the backend
     report. All other sections are built server-side. -->
<div class="pdf-report">
  <app-thematic-performance-history [tabId]="tabId" [tab_name]="tab_name" [query]="query"
    [theme_params]="themeParams" [printMode]="true">
  </app-thematic-performance-history>

  <app-thematic-innovation-activity *ngFor="let m of ACTIVITY_METRICS" [tabId]="tabId" [tab_name]="tab_name"
    [query]="query" [theme_params]="themeParams" [printMode]="true" [lockedMetric]="m">
  </app-thematic-innovation-activity>
</div>
